import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle, ArrowLeft, ShoppingCart } from 'lucide-react';
import { Button } from '../components/ui/button';

const CheckoutCancelPage = () => {
  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center py-12" data-testid="checkout-cancel">
      <div className="text-center max-w-md mx-auto px-4">
        <div className="w-20 h-20 bg-[#FF3B30]/20 rounded-full flex items-center justify-center mx-auto mb-6">
          <XCircle className="w-12 h-12 text-[#FF3B30]" />
        </div>

        <h1 className="text-3xl font-bold text-white mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
          Order Cancelled
        </h1>

        <p className="text-[#A1A7B5] mb-8">
          Your order has been cancelled. No charges have been made to your account.
        </p>

        <div className="space-y-4">
          <Link to="/checkout">
            <Button className="btn-primary w-full flex items-center justify-center space-x-2" data-testid="retry-checkout-btn">
              <ShoppingCart className="w-5 h-5" />
              <span>Return to Checkout</span>
            </Button>
          </Link>
          <Link to="/products">
            <Button className="btn-secondary w-full flex items-center justify-center space-x-2" data-testid="continue-shopping-btn">
              <ArrowLeft className="w-5 h-5" />
              <span>Continue Shopping</span>
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CheckoutCancelPage;
